import OpportunityRow from "./OpportunityRow";

/**
 * Una sección de Mi cartera ("Conversaciones por retomar", "Próximas a
 * vencer", "Prioridad alta"): encabezado con conteo + pocas filas + "Ver
 * más" si hay más. Vive como <tbody> dentro de la misma <table> que el
 * encabezado de columnas de Wallet.jsx -- así todas las secciones
 * comparten exactamente las mismas columnas sin repetir el <thead>.
 *
 * Un bloque vacío no se renderiza -- decisión sobre cantidad de
 * información (Ronda 2.1): mostrar una sección en cero no ayuda a decidir
 * qué hacer, solo agrega ruido.
 */
export default function OpportunityBlock({
  label,
  opportunities,
  visibleCount,
  onShowMore,
  selectedId,
  onSelect,
  testid,
}) {
  const count = opportunities.length;
  if (count === 0) return null;

  const visible = opportunities.slice(0, visibleCount);
  const remaining = count - visible.length;

  return (
    <tbody data-testid={testid}>
      <tr>
        <td colSpan={7} className="px-4 sm:px-6 pt-5 pb-2 bg-[#0d1321]">
          <div className="flex items-center justify-between">
            <div className="text-sm sm:text-base font-display font-bold text-zinc-100">{label}</div>
            <div className="text-zinc-500 font-mono text-sm tabular-nums">{count}</div>
          </div>
        </td>
      </tr>
      {visible.map((o) => (
        <OpportunityRow
          key={o.id}
          opp={o}
          selected={selectedId === o.id}
          onClick={() => onSelect(o.id)}
          testid={`${testid}-row-${o.id}`}
        />
      ))}
      {remaining > 0 && (
        <tr>
          <td colSpan={7} className="px-4 sm:px-6 py-1">
            {/* py-2.5 + -mx-2 px-2 agrandan el área clicable real más allá
                del texto (antes solo el glyph respondía al toque/clic) --
                relevante dentro del iframe de GHL, donde el puntero suele
                ser un dedo o un trackpad menos preciso que en escritorio. */}
            <button
              data-testid={`${testid}-show-more`}
              onClick={onShowMore}
              className="text-xs font-mono uppercase tracking-[0.12em] text-zinc-300 hover:text-amber-400 transition-colors -mx-2 px-2 py-2.5 rounded-lg hover:bg-white/[0.03]"
            >
              Ver {remaining} más
            </button>
          </td>
        </tr>
      )}
    </tbody>
  );
}
